<template>
  <div>
    <p v-if="!isSitecoreExperienceEditorOn" v-html="multiLineContent" :class="this.className" />
    <sc-text :field="multilineField" tag="p" :class="this.className" v-else />
  </div>
</template>

<script>
import { Text, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'SitecoreMultiline',
  data() {
    return {};
  },
  props: {
    multilineField: {
      type: Object,
      default: () => ({}),
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    multiLineContent() {
      let content = '';
      if (typeof(this.multilineField)!='undefined' 
          && typeof(this.multilineField.value)!='undefined' 
          && this.multilineField.value !== '') {
        content = this.multilineField.value.replace(/\r\n/g, '<br />');
      }
      return content;
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  components: {
    ScText: Text,
  },
};
</script>
<style lang="scss" scoped></style>
